import { Loading } from '@/components';
import { Navigate } from 'react-router';

import { useSearchHistory } from '@/features/project/_hooks/search-projects/local-storage';
import { useMe } from '../_hooks/me';

export const DynamicNavigate = () => {
  const me = useMe();

  const { lastSearchedQueryParams } = useSearchHistory();

  if (me.isLoading) {
    return <Loading />;
  }
  if (!me.data) {
    return <Navigate to="/login" />;
  }

  if (me.data.role.resourceGroupPermissions.project !== 'none') {
    return <Navigate to={`/rs/project?${lastSearchedQueryParams}`} />;
  }

  if (me.data.role.resourceGroupPermissions.masterTable !== 'none') {
    return <Navigate to="/master-table" />;
  }

  if (me.data.role.resourceGroupPermissions.administrator !== 'none') {
    return <Navigate to="/tenant-manager" />;
  }

  return <Navigate to="/profile" />;
};
